var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.showDialog,
        "append-to-body": "",
        top: "40px",
        width: "1000px"
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        }
      }
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        !_vm.editing
          ? _c(
              "div",
              { staticClass: "title" },
              [
                _c("h2", [_vm._v(_vm._s(_vm.title))]),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { size: "small", icon: "el-icon-edit" },
                    on: {
                      click: function($event) {
                        _vm.editing = true
                      }
                    }
                  },
                  [_vm._v("编辑标题")]
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "edit-title", staticStyle: { width: "500px" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容" },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.editing = false
                      }
                    }
                  },
                  [_vm._v("确定")]
                )
              ],
              1
            )
      ]),
      _vm.showDialog
        ? _c("Cheditor", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "cheditor",
            model: {
              value: _vm.content,
              callback: function($$v) {
                _vm.content = $$v
              },
              expression: "content"
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "btns" },
        [
          _vm.notaryStatus == 2
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.btnLoading
                  },
                  on: { click: _vm.save }
                },
                [_vm._v("保存")]
              )
            : _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "已审核的模版无法更改",
                    placement: "top"
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }